export default {
    login: {
      title: "HR BOX",
      remember: "ログインしたままにする",
      button: "ログイン",
    },
  
    //edit
    register: {
      title: "会員登録",
      username: "ユーザー名は数字と文字で構成されます",
      password: "パスワードは数字と文字で構成されます",
      password2: "確認のため、パスワードをもう一度入力してください",
      email: "メールアドレス",
      return_login: "ログインページに戻る",
      return_registerSelect: "会員プランページに戻る",
      english: "英語",
      japanese: "日文",
      usernameRule: "ユーザー名を入力してください",
      usernamePattern: "ユーザー名は半角英数字を入力してください。",
      emailRule: "メールアドレスを入力してください",
      emailPattern: "メールアドレスの入力形式が不正です。",
      passwordRule: "パスワードを入力してください",
      passwordPattern: "半角英字・数字を含め、6文字以上で入力してください。",
      registerAlert: "ご登録していただいたメールアドレス宛に HRBOX WEBシステム登録案内メール をお送りいたしました。メールをご確認ください。",
      userAlert: "ユーザ名がすでに登録されています。",
      emailAlert: "指定のメールアドレスで過去にユーザ登録されています。",
  
      registerFail: "登録できません!",
      passwordFail: "パスワードが一致しません",
      server_not_found: "サーバーが見つかりません⊙﹏⊙∥!",
  
      success: "メールをお送りいたしました。",
      fail: "メールを送信できません!",
    },
    forget: {
      title: "メールアドレスを入力して再設定を行う",
      hint: "ID·パスワードをお忘れの方は、ご登録されている会員情報と同じ内容を入力し、「送信する」ボタンを押してください。",
      button: "送信する",
      return: "ログインページに戻る",
      emailRule: "メールアドレスを入力してください",
      refill: "メールアドレスの入力形式が不正です。",
      alertMsg: "ご登録していただいたメールアドレス宛に SENSEシステム登録案内メール をお送りいたしました。メールをご確認ください。",
      not_email: "指定されたメールアドレスは存在しません",
      server_not_found: "サーバーが見つかりません⊙﹏⊙∥!",
  
      success: "パスワード再設定メールを送信しました。!",
      fail: "メールを送信できません!"
    },
  
    //edit
    reset: {
      title: "ユーザID・パスワードの再設定",
      button: "確認する",
      username: "ユーザー名は半角英数字で入力してください。",
      password: "パスワード",
      confirm: "確認のため、パスワードも一度入力してください",
      return_login: "ログインページに戻る",
      usernameRule: "ユーザー名を入力してください",
      passwordRule: "パスワードを入力してください",
      passwordPattern: "半角英字・数字を含め、6文字以上で入力してください。",
  
      reset_completed: "ユーザー名とパスワードが再設定しました。",
      usernameError: "ユーザ名がすでに登録されています、再設定できません。",
      reset_failed: "ユーザー名とパスワードが再設定できません!",
      reset_failedURL: "最新の再設定用URLをクリックしてください。!",
  
      success: "再設定完了しました!",
      fail: "再設定できません!",
  
      server_not_found: "サーバーが見つかりません⊙﹏⊙∥!",
      password_not_same: "パスワードが一致しません。",
    },
  
    //edit
    home: {
      system: "BOX",
      home: "ホーム",
      alert: "ようこそ,HR BOX!",
      alert_info: "情報",
      msg: "メッセージ",
      logout: "ログアウト",
      logout_confirm: "本当にログアウトしますか",
      guest: "ゲスト",
    },
  
    userHome: {
      username: "会員氏名",
      nickname: "ニックネーム",
      email: "メールアドレス",
      phone: "電話番号",
      password: "以前のパスワード",
      change_password: "パスワード変更",
      new_password: "新しいパスワード",
      comfirm_password: "新しいパスワードを確認",
      change_pic: "パソコンから写真を選択",
      size_limit: "1MB以内のjpg/jpeg画像が利用できます。",
      change_info: "基本情報変更",
      locale: "言語",
  
      new_password_hint_title: "パスワードの安全度:",
      new_password_hint_msg: "8文字以上にしてください。別のサイトで使用しているパスワードや、すぐに推測できる単語（たとえばペットの名前）は使用しないでください。",
  
      new_password_error: "パスワードを入力してください。",
      comfirm_password_error: "パスワードが一致しません。",
  
      jpg_format: "ユーザー画像はJPG形式である必要があります！",
      oversize: "ユーザー画像サイズは1MBを超えることはできません！",
      fill: "入力してください。",
      fill_new_pw: "新しいパスワードを入力してください。",
      fill_old_pw: "以前のパスワードを入力してください。",
      fill_comfirm_pw: "新しいパスワードを再入力してください。",
    },
    //new
    check: {
      forget: "新規会員登録が完了しました！",
      hint: "「ログインペイジ」のボタンをクリックしてください。",
      mailed: "メールを確認しました。ログインしてください。HRBOXと営業支援システムを利用のため、最初に会社情報を追加してください。",
      success: "新規会員登録が完了しました！",
      login_page: "ログインページ",
    },
  
    empMana: {
      employee_id: "従業員ID",
      cateName: "従業員名",
      employee_name_frgn: "(ふりがな)",
      employee_name_rm: "(ローマン)",
      employee_age: "年齢",
      employee_gender: "性別",
      month_salary: "月収",
      employee_tel: "電話番号",
      bank_account: "口座番号",
      date: "編集時間",
      addbutton: "新規",
      editbutton: "編集",
      detailsbutton: "詳細",
      deletebutton: "削除",
      deleteall: "一括削除",
      operation: "操作",
      inputinfo: "データを入力してください",
      cancel: "キャンセル",
      confirm: "確認",
    },
    router: {
      laborIns: {
        title: "労働保険",
        insurance_rate: "機能追加",
        labor_ins_account: "口座振替納付書",
      },
      health: {
        title: "社会保険",
        HealthInsHome: "社会保険_項目一覧",
        HealthIns1: "健康保険・厚生年金保険事業所を設立",
        HealthIns2: "被保険者住所変更届（国民年金第3号被保険者住所変更届）",
        HealthIns3: "被保険者資格取得届／厚生年金保険70歳以上被用者該当届",
        HealthIns4: "健康保険・厚生年金保険　資格取得・喪失等確認請求書",
        HealthIns5: "健康保険　被扶養者（異動）届（国民年金第3号被保険者関係届）",
        SuspensionNotice: "適用事業所が廃止、休止等により適用事業所",
        InsNameChange: "健康保険・厚生年金保険　被保険者氏名変更（訂正）届",
        InsDisqualifyNotice: "被保険者資格喪失届／厚生年金保険70歳以上被用者不該当届",
        InsQualifyNotice: "健康保険　被保険者資格証明書交付申請書",
        Childcare_Application: "健康保険・厚生年金保険育児休業等取得者申出書終了届",
        Childcare_Application_Salary_Change: "健康保険・厚生年金保険被保険者育児休業等終了時報酬月額変更届",
  
  
      },
      empIns: {
        title: "雇用保険",
        empInsHome: "雇用保険_項目一覧",
        empIns1: "雇用保険事業主事業所各種変更届",
        empIns2: "雇用保険適用事業所設置届",
        empIns3: "雇用保険被保険者離職票再交付申請書",
        empIns4: "雇用保険被保険者資格取得届",
        empIns8: "雇用保険適用除外申請書",
        empIns10: "資格喪失届光ディスク等提出用総括票",
      },
      basic: {
        title: "基本台帳",
        company: "会社情報",
        homePage: "ホーム",
        laborIns: "労働保険関係",
        fileList: "書類一覧",
      },
      hr: {
        title: "人事管理",
        list: "従業員情報",
        empPDF: "労働者名簿印刷",
        EmpListResign: "退職者情報",
      },
      adj: {
        title: "年末調整",
        taxForm: "給与所得の源泉徴収票",
        declaration: "扶養控除申告",
        pensionadmin: "算定基礎届",
        pensionbasic: "報酬月額管理",
        PensionReissue: "年金手帳再交付申請書",
        AttoneryPower: "委任状",
        EndYearAdjHome: "年末調整機能一覧",
        taxBook: "源泉徴収簿",
        taxFormLeave: "退職所得の源泉徴収票",
        insDeclaration: "保険料控除申告書",
        basicDeclaration: "基礎控除申告書",
        nextDeclaration: "翌年分撫養控除申告書",
      },
      attendance: {
        title: "勤怠管理",
        manage: "勤怠管理",
        userHome: "アカウント設定",
      },
      user: {
        title: "ユーザー管理",
        manage: "ユーザー管理",
      },
      cacl: {
        title: "便利ツール",
        calculator:"税金等計算",
        fileList: "書類一覧",
        nkhk: "年金保険",
        jdsloan: "自動車ローン",
        jtkloan: "住宅ローン",
        gscsh_month: "源泉徴収税（月額）",
        salary: "給与明細",
      },
      social: {
        title: "社会保険",
        social_ins_steps: "社会保険流れ",
        pension_reissue: "年金手帳再交付申請書",
        attorney_power: "委任状",
      },
      detail: {
        manage: "詳細情報",
        empIns5: "個人番号登録・変更届",
        empIns6: "再就職手当支給申請書",
        empIns7: "適用事業所廃止届",
        empIns8: "適用除外申請書",
        empIns9: "被保険者資格喪失届・氏名変更届",
        empIns10: "資格喪失届光ディスク等提出用総括票",
        empIns11: "資格取得届光ディスク等提出用対象者名簿",
        empIns12: "雇用保険被保険者転勤届",
        empIns13: "雇用保険の被保険者である外国人に係る届出",
        empIns14: "雇用保険の被保険者ではない外国人に係る届出",
      },
      sarary: {
        // title: "報酬月額",
        // pensionadmin: "算定基礎届",
        // pensionbasic: "報酬月額管理",
        title: "年末調整",
        pensionadmin: "扶養控除",
        pensionbasic: "源泉徴収票",
      },
    },
  
    //these are variable that included common
    general: {
      select: "選択",
      preview: "プレビュー",
      refresh: "更新",
      add: "新規",
      edit: "編集",
      detail: "詳細情報",
      delete: "削除",
      operation: "操作",
      print: "プレビュー",
      inputinfo: "データを入力してください",
      cancel: "キャンセル",
      confirm: "OK",
      print_completed: "サーバー送信しました!",
      print_failed: "プレビューできません!",
      hint: "ピント",
      sure_delete: "本当に削除しますか",
      delete_completed: "削除しました!",
      delete_failed: "削除できません!",
      canceled: "キャンセル済み",
      close_comfirm: "閉じてもよろしいですか？",
      current_page: "現在ページ:",
      add_completed: "新規作成しました！!",
      add_failed: "新規作成できません!",
      edit_completed: "更新しました!",
      edit_failed: "更新できません!",
      general_info: "基本情報",
      please_select: "選択してください。",
      detail: "詳細情報",
      hint: "ヒント",
      warning: "注意",
      empty_data: "データなし",
      valid_failed: "必須項目が入力されていません！",
  
      employee_id: "社員番号",
  
      remark: "備考",
      other: "その他",
      date: "申請日",
      close: "閉じる",
      uploadCompleted: "写真をアプロードしました。"
  
    },
  
  
    //companyInfo
    //new
    companyInfo: {
      name: "事業所の名称", //Table
      addressT: "本社住所", //Table
  
      detail: "詳細情報",
  
      office_info: "企業情報",
      name1: "事業所名称",
      name1P: "全角で入力してください",
      name_kn1: "事業所名称（フリガナ）",
      name_kn1P: "全角で入力してください",
      chairman: "代表者氏名",
      chairmanP: "＜例＞：事業　太郎",
      chairman_ka: "代表者氏名「フリガナ」",
      chairman_kaP: "全角で入力してください",
      chairman_code: "法人番号",
      company_code: "事業所コード",
      establishment_date: "事業開始年月日",
      end_date: "事業廃止年月日",
      capital: "資本金（万円）",
      emp_amount: "従業員数",
      business_overview: "事業の種類",
  
      address: "所在地",
      address0: "所在地（都道府県）",
      address1: "所在地（市区町村まで）",
      address2: "番地",
      address3: "建物名",
      address_frgn0: "所在地（都道府県）「フリガナ」",
      address_frgn1: "所在地（市区町村まで）「フリガナ」",
      address_frgn2: "番地「フリガナ」",
      address_frgn3: "建物名「フリガナ」",
      province:"都道府県",
      city: "市・区・郡及び町村名",
      street: "丁目・番地",
      building: "ビル、マンション名等",
      postal_code: "郵便番号",
      tel: "電話番号",
  
      insuranceInfo: "保険情報",
      emp_insurance_code: "雇用保険番号",
      emp_insurance_codeP: "雇用保険番号を入力してください",
      labor_insurance_code: "労働保険番号",
      labor_insurance_codeP: "労働保険番号を入力してください",
      begin_day_emp: "雇用保険成立日",
      begin_day_labor: "労災保険成立日",
  
      salary: "給与・税",
      salary_close_day: "給与締め日",
      salary_day: "給与支給日",
      tax_office: "管轄の税務署",
      tax_officeP: "法人のときは代表者の氏名",
      ins_amount: "被保険者数（一般）",
      insamount_day: "被保険者（日雇）",
      health_ins_code: "事業所番号",
      health_company_num: "事業所整理記号",
      
      filltel:"正しいフォーマット入力してください",
      fillname:"正しいフォーマット入力してください",
      fill: "入力してください",
      fillRules:"全角で入力してください",
      fillRules2:"半角で入力してください",
      fillRules3:"半角数字で入力してください",
  
      open1Title: "法人番号とは:",
      open1Msg: "検査用数字（1桁） ＋ 会社法人等番号（12桁）を合わせた数字13桁からなる番号の事です。https://www.houjin-bangou.nta.go.jp/",
  
      open2Title: "雇用保険 事業所番号とは:",
      open2Msg: "事業所ごとに付与された11桁（4桁-6桁-1桁）の数字です。（例）12345678901「適用事業所台帳（雇用保険適用事業所設置届事業主控）」「雇用保険被保険者資格取得等確認通知書（事業主通知用）」などに記載されています。",
  
      open3Title: "雇用保険の労働保険番号とは:",
      open3Msg: "2桁-1桁-2桁-6桁-3桁の5つの区分からなる合計14桁の数字です。過去の労働保険の概算・確定保険料申告書、労災保険申請書、労働保険の年度更新申告書などに記載されています。",
  
      open4Title: "管轄の税務署とは:",
      open4Msg: "所属する納税地により管轄している税務署が決められています。ご不明の場合には下記URLよりご確認下さい：https://www.nta.go.jp/about/organization/access/map.htm",
  
      cant: "追加できる会社情報は一つだけです",
  
      example: "例......",
  
      company_code_example: "＜例＞：1236985866543（半角） ",
      capital_example: "＜例＞：1000万",
      emp_amount_example: "＜例＞：100",
      business_overview_example: "＜例＞：製造業",
      postal_code_example: "＜例＞：000-0000",
      tel_example: "＜例＞：03-1234-5678"
    },
  
    //Employee //HR Maganger
    //new
    empList: {
      close: "閉じる",
      general_info: "基本情報",
      name: "氏名",
      name_rm: "氏名（英表記大文字）",
      name_frgn: "氏名（フリガナ）",
      nation: "国籍・地域",
      birthday: "生年月日",
      gender: "性別",
      male: "男",
      female: "女",
      email: "メールアドレス",
      mynum: "マイナンバー",
  
      nameP: "＜例＞：社員　太郎",
      name_frgnP: "＜例＞：シャイン　タロウ",
      employee_idP: "社員番号を半角英数字で入力してください",
      birthdayP: "生年月日を入力してください。",
      emailP: "半角英数字で入力してください",
      mynumP: "マイナンバーを半角数字で入力してください",
  
      assign_resign: "入退社情報",
      begin_date: "入社年月日",
      end_date: "離職年月日",
      work_status: "在籍状況",
      cause: "離職理由",
  
      begin_dateP: "入社年月日を入力してください。",
      end_dateP: "離職年月日を入力してください。",
  
      office_info: "業務情報",
      employee_type: "雇用形態",
      work_content: "業務内容",
      title: "役職",
  
      work_contentP: "業務内容を入力してください",
      titleP: "役職を入力してください",
  
      contact_info: "住所と連絡先",
      address1: "住所",
      address2: "番地",
      address3: "建物名",
      city: "都道府県、市・区・郡及び町村名",
      street: "丁目・番地",
      building: "ビル、マンション名等",
      postal_code: "郵便番号",
  
      address_frgn1: "所在地（フリガナ）",
      address_frgn2: "番地（フリガナ）",
      address_frgn3: "建物名（フリガナ）",
  
      tel: "電話番号",
      telP: "＜例＞：080-1234-5678",
  
      salary: "給与と銀行口座",
      bank_name: "金融機関名",
      bank_name_frgn: "金融機関名（フリガナ）",
      deposit_type: "預金種別",
      account_name: "口座名義",
      commuting_fee: "通勤手当",
      bank_branch: "支店・出張所名",
      bank_branch_frgn: "支店名（フリガナ）",
      bank_code: "金融機関コード",
      branch_code: "店舗コード",
      account: "口座番号",
      accountU: "記号番号",
      salary_month: "報酬月額（円）",
      salary_changeday: "報酬月額改定年月",
  
      resident_info: "在留資格情報（外国人の場合）",
      resident: "在留資格",
      resident_code: "在留カード番号",
      resident_date: "在留期間満了日",
  
      insurance_info: "保険情報",
      emp_insuranceID: "雇用保険番号",
      emp_ins_begin_day: "雇用保険資格取得日",
      emp_ins_end_day: "雇用保険資格喪失日",
      basic_pensionID: "基礎年金番号",
      pensionID: "厚生年金整理番号",
      health_insuranceID: "健康保険番号",
  
      basic_pensionIDP: "基礎年金番号を入力してください",
      pensionIDP: "厚生年金整理番号を入力してください",
      health_insuranceIDP: "健康保険番号を入力してください",
  
      family_info: "扶養親族",
      family_add: "扶養家族を追加する",
      family_print: "扶養控除申告書",
      relation: "続柄",
  
      dependent_info: "編集扶養家族",
  
      income: "取得の見積額",
      relation: "続柄",
      work: "生計を一にする事実",
  
      social_ins_status: "社会保険の扶養状況",
      date: "被扶養者でなくなった日",
      tax_status: "所得税の扶養状況",
  
      address: "住所",
  
      new_family_info: "新規扶養家族",
  
      aus: "AUS-オーストラリア",
      bra: "BRA-ブラジル",
      mmr: "MMR-ミャンマー",
      can: "CAN-カナダ",
      chn: "CHN-中国",
      fra: "FRA-フランス",
      deu: "DEU-ドイツ",
      hkg: "HKG-中国香港",
      ind: "IND-インド",
      jpn: "JPN-日本",
      kor: "KOR-韓国",
      phl: "PHL-フィリピン",
      twn: "TWN-台湾",
      tha: "THA-タイ",
      usa: "USA-アメリカ",
      vnm: "VNM-ベトナム",
      r1: "01-教授",
      r2: "02-芸術",
      r3: "03-宗教",
      r4: "04-報道",
      r5: "05-高度専門職１号",
      r6: "06-高度専門職２号",
      r7: "07-経営・管理",
      r8: "08-法律・会計業務",
      r9: "09-医療",
      r10: "10-研究",
      r11: "11-教育",
      r12: "12-技術・人文知識・国際業務",
      r13: "13-企業内転勤",
      r14: "14-介護",
      r15: "15-興行",
      r16: "16-技能",
      r17: "17-特定技能１号",
      r18: "18-特定技能２号",
      r19: "19-技能実習１号",
      r20: "20-技能実習２号",
      r21: "21-技能実習３号",
      r22: "22-文化活動",
      r23: "23-短期滞在",
      r24: "24-留学",
      r25: "25-研修",
      r26: "26-家族滞在",
      r27: "27-特定活動",
      r28: "28-永住者",
      r29: "29-日本人の配偶者等",
      r30: "30-永住者の配偶者等",
      r31: "31-定住者",
  
      none: "なし",
  
      in_office: "在職中",
      on_leave: "休職中",
      retired: "退職済",
  
      wife: "妻",
      husband: "夫",
      mother: "実母",
      father: "実父",
      mother_in_law: "義母",
      father_in_law: "義父",
      eldest_son: "長男",
      eldest_daughter: "長女",
      second_son: "二男",
      second_daughter: "二女",
      elder_brother: "兄",
      elder_sister: "姉",
      younger_brother: "弟",
      younger_sister: "妹",
      grandfather: "祖父",
      grandmother: "祖母",
  
      dont_support: "扶養しない",
      support: "扶養する",
      not_sure: "不明",
  
      officer: "役員",
      permanent: "正社員",
      contract: "契約社員",
      temporary: "派遣社員",
      part_time: "アルバイト",
  
      deposit: "普通",
      checking: "当座",
      savings: "貯蓄",
  
      nameRule: "氏名を入力してください",
      work_statusRule: "在籍状況を選択してください",
      begin_dateRule: "入社年月日を入力してください",
      employee_typeRule: "雇用形態を選択してください",
      emailRule: "メールアドレスを入力してください",
      name_fnRule: "氏名（フリガナ）を入力してください",
      nation_rule:"国籍を選択してください",
      gender_rule:"性別を選択してください",
      employee_idRule: "社員IDを入力してください",
      work_contentRule: "業務内容を入力してください",
      titleRule: "役職を入力してください",
      telRule: "電話番号を入力してください",
      postRule:"郵便番号を入力してください",
  
      open1Title: "マイナンバーとは:",
      open1Msg: "マイナンバーとは、日本に住民票を有するすべての方（外国人の方も含まれます。）が持つ12桁の番号です。※原則として自由に変更することはできません。",
  
      open2Title: "雇用保険番号とは:",
      open2Msg: "被保険者番号は、「4桁-6桁-1桁」で構成される、合計11桁の番号です。 会社に入社して雇用保険に加入すると原則一人にひとつ割り当てられ、退職後に転職先で再度雇用保険に加入する際も同じ被保険者番号を使います。",
  
      open3Title: "基礎年金番号は:",
      open3Msg: "国民年金・厚生年金保険・共済組合といったすべての公的年金制度で共通して使用する「一人に一つの番号」です。 基礎年金番号の体系基礎年金番号は10桁の数字で表され、4桁と6桁の組み合わせとなっています。",
  
      open4Title: "厚生年金整理番号とは:",
      open4Msg: "厚生年金資格取得届等の控えを見て確認します。健康保険被保険者整理番号と共通の数字なっていることが多いですが、異なる場合もありますので厚生年金資格取得届等の控えを参照します。",
  
      open5Title: "健康保険番号とはとは:",
      open5Msg: "健康保険番号は、健康保険証の券面に記載があります。全国健康保険協会の場合、健康保険証の表面・上部に記載されている「記号・番号」欄の「番号」にあたる部分が健康保険被保険者整理番号となります。",
  
      example: "例......",
      postal_code_example: "＜例＞：000-0000",
      fill: "入力してください",
      numInput: "半角数字で入力してください",
      
    },
  
    //new
    empPDF: {
      name: "氏名",
      name_frgn: "氏名「フリガナ」",
      gender: "性別",
      begin_date: "雇入年月日",
      history: "履歴",
      dismiss_date: "解雇・退職・死亡の年月日",
      address: "現住所",
      birthday: "生年月日",
      work_content: "業務の種類",
      dismiss_reason: "解雇・退職・死亡の事由"
  
    },
  
    //LaborIns
  
    //new
    laborInsInfo: {
      type: "項目種別",
      amount_labor: "労働保険者数",
      amount_emp: "雇用保険者数",
      amount_old: "高齢者数",
      business_overview: "事業概要",
      business_type: "事業種類",
      total_money: "売上高",
      continued: "0:保険関係成立届（継続）",
      fixed: "1:保険関係成立届（有期）",
      voluntary: "2:任意加入申請書",
  
      people_example: "例：100",
      business_overview_example: "例：製造業",
      business_type_example: "例：定置網漁業又は海面魚類養殖業",
      total_money_example: "例：100万",
  
      name: "事業所の名称",
      example: "例......",
    },
    labor_ins_account: {
      designated_deposit_account: "指定預金口座",
      bank_account: "銀行口座",
      bank_code: "金融機関コード",
      bank_store_code: "店舗コード",
      account_name_kana: "口座名義（カナ）",
      account_name: "口座名義（漢字） ",
      bank_transfer_type: "データ指示コード",
  
      transfer_payment_deadline: "振替納付期日",
      bank_transfer_start_date: "振替開始（希望）納期",
      era: "元号",
      year: "年度",
      term: "期分",
      bank_transfer_start_date_era: "振替開始（希望）納期（元号）",
      bank_transfer_start_date_year: "振替開始（希望）納期（年度）",
      bank_transfer_start_date_term: "振替開始（希望）納期（期）",
      submit_date: "提出年月日",
      employee_id: "社員番号",
      name: "社員氏名",
  
      enter_employee_id: "社員番号を入力してください",
    },
  
    // HealthIns
  
    healthIns1: {
      general_info: "基本情報",
      labor_ins_name: "社会保険労務士名",
      health_ins_name_pho: "健康保険組合名「フリガナ」",
      health_ins_name: "健康保険組合名",
      welfare_pension_no: "厚生年金基金番号",
      welfare_pension_name: "厚生年金基金名",
      allowrance: "現物給与の種類",
      food: "食事",
      housing: "住宅",
      clothing: "被服",
      commuter_pass: "定期券",
      other: "その他",
      allowrance1st: "昇給月: 1回目",
      allowrance2nd: "昇給月: 2回目",
      allowrance3rd: "昇給月: 3回目",
      allowrance4th: "昇給月: 4回目",
      bonus: "賞与支払予定月",
      first: "1回目",
      second: "2回目",
      third: "3回目",
      fourth: "4回目",
      agent: "事業主代理人",
      agent_name: "事業主代理人氏名",
      agent_address: "事業主代理人住所",
      category: "個人・法人等区分",
      office_category: "本・支店区分",
      no_category: "番号等区分",
      country_category: "内・外国区分",
      remark: "備考",
      not_exist: "無",
      exist: "有",
      corp: "法人",
      individual: "個人",
      national: "国・地方公共団体",
      corp_no: "法人番号",
      company_no: "会社法人等番号",
      main_office: "本店",
      branch_office: "支店",
      domestic: "内国法人",
      foreign: "外国法人",
      otherHintTitle: "その他",
      otherHintMsg: "その他の現物給与の種類を記入してください。",
      agentHintTitle: "事業主代理人",
      agentHintMsg: "「有」の場合は、氏名及び住所を記入してください。",
      div1HintTitle: "個人・法人等区分",
      div1HintMsg: "「個人」を選択した場合は、以下の情報が記入は不要です。",
    },
    healthIns2: {
      name: "氏名",
      remark: "備考",
      insured_info: "被保険者情報",
      employee_id: "社員番号",
      mynum: "個人番号",
      birthday: "生年月日",
      arrange_num: "整理番号",
      before_address_pref: "変更前住所「都道府県」",
      before_address: "変更前住所「市町村」",
      change_post: "変更後郵便番号",
      change_address_pho: "変更後住所「ﾌﾘｶﾞﾅ」",
      change_address_pref: "変更後住所「都道府県」",
      change_address: "変更後住所「市町村」",
      change_date: "住所変更年月日",
      other: "その他",
      spouse: "被扶養配偶者の住所変更欄",
      s_name: "配偶者氏名",
      s_name_frgn: "配偶者氏名「ﾌﾘｶﾞﾅ」",
      s_mynum: "配偶者個人番号",
      together: "被保険者と配偶者は同居している。",
      yes: "はい",
      no: "いいえ",
      short_term: "短期在",
      oversea: "海外居住",
      other_resident: "住民票住所以外の居所",
      s_first_nameRule: "配偶者名を入力してください",
      s_last_nameRule: "配偶者氏を入力してください",
      s_first_name_knRule: "配偶者名「ﾌﾘｶﾞﾅ」を入力してください",
      s_last_name_knRule: "配偶者氏「ﾌﾘｶﾞﾅ」を入力してください",
      s_birthdayRule: "生年月日を入力してください",
      s_before_address_prefRule: "変更前住所「都道府県」を入力してください",
      s_before_addressRule: "変更前住所を入力してください",
      change_postRule: "変更後郵便番号を入力してください",
      change_address_phoRule: "変更後住所「ﾌﾘｶﾞﾅ」を入力してください",
      change_address_prefRule: "変更後住所「都道府県」を入力してください",
      change_addressRule: "変更後住所を入力してください",
      moving_dateRule: "住所変更年月日を選択してください",
      remarkRule: "備考を選択してください。",
      arrange_numRule: "入力してください",
      otherRule: "その他の備考を入力してください",
      otherHintMsg: "その他の理由を記入してください。",
    },
    healthIns3: {
      submission_date: "提出年月日",
      print_no: "印刷対象社員数",
      office_name: "事業所名称",
      chairman_name: "事業主氏名",
      person: "人",
      emp1: "社員１",
      emp2: "社員２",
      emp3: "社員３",
      emp4: "社員４",
      employee_id: "社員番号",
      dependent: "被扶養者",
      payment: "通貨",
      payment_amount: "通貨の金額",
      remark: "備考",
      relevant_date: "取得（該 当）年月日",
      item: "現物",
      item_amount: "現物の金額",
      type: "種別",
      total: "報酬月額",
      other_remark: "備考:その他",
      postal_code: "郵便番号",
      address_pho: "住所「フリガナ」",
      address: "住所",
      reason: "理由",
      other: "その他",
      other_reason: "理由: その他",
  
      note: "日本年金檄横に提出する際、個人番号を記入した場合は、住所記入は不要です。",
      over70: "70歳以上被用者該当",
      over_two: "二以上事業所勤務者の取得",
      part_time: "短時間労働者の取得（特定適用事業所等）",
      re_emp: "退職後の継続再雇用者の取得",
      exist: "有",
      not_exist: "無",
      male: "男",
      female: "女",
      miner: "坑内員",
      male_fund: "男（基金）",
      female_fund: "女（基金）",
      miner_fund: "坑内員（基金）",
      oversea: "海外在住",
      short_term: "短期在留",
      print_noHint: "印刷したい人数を選れんでください。",
      cant_change: "印刷したい人数を変更できません。",
      detail: "詳細情報",
      totalHintMsg: "通貨 ＋　現物",
      close: "閉じる",
    },
    healthIns4: {
      submission_date: "提出年月日",
      employee_id: "保険者社員番号",
      name: "保険者氏名",
      birthday: "保険者生年月日",
      relation: "続柄",
      relationship: "申請者と保険者の続柄",
      other_relationship: "その他の続柄",
      
      applicant_info: "申請者情報",
  
      dependent: "申請者が被扶養者です。",
      delegator_send_date: "保険者に委する日",
      delegator_name: "委任者氏名",
      delegator_address: "委任者住所",
      delegator_relation: "委任者と申請者の関係",
      
      apply_name: "申請者氏名",
      apply_name_flgn: "申請者氏名「フリガナ」",
      apply_postcode: "申請者の郵便番号",
      apply_address: "申請者の住所",
      apply_phone: "申請者の電話番号",
      apply_phone_ex: "＜例＞000-1111-2222",
  
  
  
      reason: "理由",
      other: "その他",
      empty_data: "データはありません",
      family: "家族情報",
      f_name: "氏名",
      f_birthday: "生年月日",
      close: "閉じる",
      self: "本人",
      emp: "社員",
      join: "国民健康保険の加入（脱退） 手続き",
      yes: "はい",
      no: "いいえ",
      apply_dateRule: "申請日を選択してください。",
      delegator_send_dateRule: "保険者に委する日を選択してください。",
      relationRule: "申請者と保険者の続柄を選択してください。",
      reasonRule: "理由を入力してください。",
      other_reasonRule: "その他の理由を入力してください。",
      employee_idRule: "社員番号を選択してください。",
    },
    healthIns5: {
      submission_date: "提出年月日",
      ins_info: "被保険者情報",
      employee_id: "社員番号",
      name: "氏名",
      birthday: "生年月日",
      gender: "性別",
      mynum: "個人番号",
      acq_date: "取得年月日",
      income: "年収",
      reference_no: "被保険者整理番号",
      spouse: "被扶養配偶者",
      deliver_date: "届年月日",
      third_person: "第３号被保険者関係届の提出は配偶者（第２号被保険者）に委任します。",
      s_name: "配偶者氏名",
      s_name_pho: "配偶者氏名「ﾌﾘｶﾞﾅ」",
  
      relation: "続柄",
      other_relation: "その他の続柄",
  
      husband: "夫",
      wife: "妻",
      husband_fund: "夫（夫届）",
      wife_fund: "妻（妻届）",
  
      foreign_name: "外国人通称名",
      foreign_name_pho: "外国人通称名「ﾌﾘｶﾞﾅ」",
  
      nationality: "国籍",
  
      address: "住所",
      postal_code: "郵便番号",
  
      together: "同居",
      seperate: "別居",
  
      home: "自宅",
      mobile: "携帯",
      work: "勤務先",
      other: "その他",
      phone: "電話番号",
      phone_ex: "＜例＞000-1111-2222",
  
      type: "申込タイプ",
      oversea_type: "海外特例要件タイプ",
  
      applicable: "該当",
      not_applicable: "非該当",
      change: "変更",
  
      oversea_applicable: "海外特例要件該当",
      oversea_not_applicable: "海外特例要件非該当",
      remark: "備考",
  
      applicable_note: "該当する場合は以下に記入してください。",
      not_applicable_note: "非該当／変更する場合は以下に記入してください。",
      oversea_applicable_note: "海外特例要件に該当する場合は以下に記入してください。",
      oversea_not_applicable_note: "海外特例要件に非該当する場合は以下に記入してください。",
  
      d_become_date: "被扶養者になった日",
      d_change_date: "被扶養者になくなった日",
  
      oversea_become_date: "海外特例要件に該当日",
      oversea_change_date: "海外特例要件に非該当日",
  
      reason: "理由",
      marriage: "婚姻",
      leave_job: "離職",
      income_decrease: "収入減少",
      other: "その他",
      other_reason: "その他の理由",
  
      death: "死亡",
      divorce: "離婚",
      income_increase: "就職・収入増加",
      age_75: "75歳到達",
      failure: "障害認定",
      death_date: "死亡年月日",
  
      s_occupation: "配偶者の就職",
      employed: "職業",
      unemployed: "無職",
      part_time: "パート",
      pensioner: "年金受給者",
      other_occupation: "その他の職業",
  
  
      study_abroad: "留学",
      acc_family: "同行家族",
      specific: "特定活動",
      oversea_marriage: "海外婚姻",
  
      domestic_transfer: "国内転",
      domestic_transfer_date: "国内転日",
  
      dependent1: "被扶養者建欄１",
      dependent2: "被扶養者建欄２",
  
      ins_last_name: "被保険者氏",
      ins_first_name: "被保険者名",
      ins_last_name_pho: "被保険者氏「ﾌﾘｶﾞﾅ」",
      ins_first_name_pho: "被保険者名「ﾌﾘｶﾞﾅ」",
  
      child: "実子・養子",
      other_child: "実子・養子以外の子",
      parent: "父母・養父母",
      in_law: "義父母",
      elder_sibling: "兄姉",
      younger_sibling: "弟妹",
      grand_parent: "祖父母",
      great_grand_parent: "曽祖父母",
      grand_child: "孫",
  
      birth: "出生",
      d_income_decrease: "収入減",
      elementary: "小・中学生以下",
      high: "高・大学生",
      grade: "年生",
  
      d_employed: "就職",
      d_income_increase: "収入増加",
  
      male: "男",
      female: "女",
  
      reference_noHint: "資格取得時に払い出しされた被保険者整理番号をご記入ください。被保険者資格取得届と同時に提出する場合は記入不要です。",
      change_dateHint: "被扶養者（第3号被保険者）でなくなった日です。",
      become_dateHint: "被扶養者（第3号被保険者）になった日です。",
    },
  
    ins_disqualify_notice: {
      report_date: "提出年月日",
      office_ref_num: "事業所整理記号",
      no_of_emp_to_print: "印刷対象社員数",
  
      employee_id: "社員番号1",
      ins_ref_num: "被保険者整理番号1",
      loss_date: "喪失年月日1",
      loss_cause: "喪失原因1",
      retired_date: "退職等年月日1",
      death_date: "死亡年月日1",
      remark: "備考1",
      remark_other: "備考その他1",
      transfer_date: "転勤年月日1",
      ins_card_collection_attachment: "保険証回収添付1",
      ins_card_collection_irreversible: "保険証回収添付返不能1",
      not_for_70_year: "70歳以上被用者不該当1",
      not_for_70_year_date: "70歳不該当年月日1",
  
      employee_id2: "社員番号2",
      ins_ref_num2: "被保険者整理番号2",
      loss_date2: "喪失年月日2",
      loss_cause2: "喪失原因2",
      retired_date2: "退職等年月日2",
      death_date2: "死亡年月日2",
      remark2: "備考2",
      remark_other2: "備考その他2",
      transfer_date2: "転勤年月日2",
      ins_card_collection_attachment2: "保険証回収添付2",
      ins_card_collection_irreversible2: "保険証回収添付返不能2",
      not_for_70_year2: "70歳以上被用者不該当2",
      not_for_70_year_date2: "70歳不該当年月日2",
  
      employee_id3: "社員番号3",
      ins_ref_num3: "被保険者整理番号3",
      loss_date3: "喪失年月日3",
      loss_cause3: "喪失原因3",
      retired_date3: "退職等年月日3",
      death_date3: "死亡年月日3",
      remark3: "備考3",
      remark_other3: "備考その他3",
      transfer_date3: "転勤年月日3",
      ins_card_collection_attachment3: "保険証回収添付3",
      ins_card_collection_irreversible3: "保険証回収添付返不能3",
      not_for_70_year3: "70歳以上被用者不該当3",
      not_for_70_year_date3: "70歳不該当年月日3",
  
      employee_id4: "社員番号4",
      ins_ref_num4: "被保険者整理番号4",
      loss_date4: "喪失年月日4",
      loss_cause4: "喪失原因4",
      retired_date4: "退職等年月日4",
      death_date4: "死亡年月日4",
      remark4: "備考4",
      remark_other4: "備考その他4",
      transfer_date4: "転勤年月日4",
      ins_card_collection_attachment4: "保険証回収添付4",
      ins_card_collection_irreversible4: "保険証回収添付返不能4",
      not_for_70_year4: "70歳以上被用者不該当4",
      not_for_70_year_date4: "70歳不該当年月日4",
  
      emp1: "社員１",
      emp2: "社員２",
      emp3: "社員３",
      emp4: "社員４",
  
      enter_office_ref_num: "事業所整理記号を入力してください",
      enter_ins_ref_num: "被保険者整理番号を必ずご記入ください",
  
      hint_insRefNumMesg_title: "被保険者整理番号",
      hint_insRefNumMesg: "資格取得時に払い出しされた被保険者整理番号",
      hint_lossDateMesg_title: "喪失年月日",
      hint_lossDateMesg: "退職等による資格喪失⇒退職日の翌日、転勤の当日、雇用契約変更の当日　｜｜　死亡による資格喪失⇒死亡日の翌日　｜｜　75歳到達による健康保険の資格喪失⇒誕生日の当日　｜｜　障害認定による健康保険の資格喪失⇒認定日の当日",
      hint_open3_title: "退職日",
      hint_open3: "退職を選択する時、退職日の翌日を記入してください・",
      hint_open4_title: "死亡日",
      hint_open4: "死亡を選択する時、死亡日の翌日記入してください・",
      hint_open5_title: "添付書類",
      hint_open5: "本人及び被扶養者すべての「健康保険被保険者証」 || 健康保険被保険者証が回収できないときは、 「健康保険被保険者証回収不能届」 || 健康保険被保険者証を紛失や盗難等により無く したときは、 「健康保険被保険者証滅失届」 || 健康保険高齢受給者証が交付されているときは 「健康保険高齢受給者証」",
      hint_not70Year_title: "70歳不該当",
      hint_not70Year: "70歳以上の方について提出する場合は、「はい」を選択してください。",
      hint_lossReasonMesg_title: "喪失原因",
      hint_lossReasonMesg: "該当する番号を囲んでください。（退職、死亡の場合は、その当日の年月日をご記入ください。",
      hint_not70YearDateMesg_title: "70歳不該当年月日",
      hint_not70YearDateMesg: "退職日、又は、死亡日を記入してください。",
      hint_otherListMesg_title: "備考",
      hint_otherListMesg: `2カ所以上の適用事業所で勤務している被保険者が喪失する場合、「1.二以上事業所勤務者の喪失」を選択してください。
        60歳以上の者で、退職した者が1日の空白もなく引き続き再雇用された場合、「2.退職後の継続再雇用者の喪失」を選択し、この届書とあわせて『被保険者資格取得届』をご提出ください。
        転勤により資格喪失する場合は、「3.その他」を選択し、「備考その他」に「1. 転勤により資格喪失する」を選択し、「転勤年月日」を記入してください。
        厚生年金基金の加入員である被保険者であって被保険者の資格を取得した月にその資格を喪失した者については、「「3.その他」を選択し、「備考その他」に「2. 加入員の資格同月得喪」を選択してください。
      `,
    },
  
    ins_name_change: {
      office_ref_num: "事業所整理記号",
      ins_ref_num: "被保険者整理番号",
      title_name: "被保険者（変更前氏名と変更後氏名）",
      first_nm_mae: "変更前の姓名",
      last_nm_mae: "変更前の名",
      first_nm_go: "変更後の氏",
      last_nm_go: "変更後の名",
      first_nm_furi: "変更後の氏(フリガナ)",
      last_nm_furi: "変更後の名(フリガナ)",
      type: "種別（性別）",
      remark: "備考",
      submit_date: "提出年月日",
      employee_id: "社員番号",
      name: "社員氏名",
      enter_office_ref_num: "事業所整理記号を入力してください",
      enter_ins_ref_num: "被保険者整理番号を入力してください",
      enter_first_nm_go: "被保険者の氏を入力してください",
      enter_last_nm_go: "被保険者の名を入力してください",
      hint_open1: "被保険者証を記入してください。",
      hint_open2: "被保検者が坑内員以外の男子であるときは「1」を、女子であるときは「2」を、坑内員であるときは「３」を○印で囲んでください。ただし、厚生年金基金の加入員であって、坑内員以外の男子であるときは「5」を、女子であるときは「６」を、坑内員であるときは「7」。",
      gender_type: "種別（性別）",
      office_ref_hint: "事業所整理記号とは、社会保険に新規加入した際の「決定通知書」で会社ごとに付与される番号のことで、左上に記載されている数字とカタカナです。",
      ins_ref_hint: "健康保険証の券面に記載があります。 全国健康保険協会（以下、協会けんぽ）の場合、健康保険証の表面・右上部に記載されている「記号・番号」欄の「番号」にあたる部分が健康保険被保険者整理番号となります。",
    },
  
    ins_qualify_notice: {
      application_date: "申請年月日",
      office_ref_num: "事業所整理記号",
      message1: "事業所整理記号を入力してください",
      message2: "社員番号を入力してください",
      qualify_date: "資格取得年月日",
      employee_id: "社員番号",
      name: "社員氏名",
    },
  
    suspension_notice: {
      office_ref_num: "事業所整理記号",
      report_date: "提出年月日",
      resume_date: "事業再開見込年月日",
      zensou_name: "氏名",
      zensou_date: "年月日",
      zensou_postcode: "郵便番号",
      zensou_address: "住所",
      zensou_tele: "電話番号",
      reason: "事由",
      zensou_causes: "原因",
      resume_date: "事業再開見込年月日",
      enter_office_ref_num: "事業所整理番号を入力してください",
      hint_open1: "「喪失の原因」が「休業2」の場合、事業を再開する見込年月日を記入してください。",
      hint_open2: "喪失の事由を詳しく記入してください。例（昨今の景気後退のあおりを受け業績悪化が続いていたところ、金融機関の融資条件を満たすことが困難となったため、今般、廃業を決め、法人解散に至ったもの。)",
      hint_reasonMesg: `解散 1：事業を廃止又は法人を解散した場合 || 
          休業 2：事業を休止(休業)した場合 ||
          合併 3：他の事業所と合併した場合 ||
          任適脱退認可 4：任意適用事業所が認可取消を申請する場合 ||
          一括適用 8：同一事業主の二以上の適用事業所が一の事業所となる承認を受けた場合`,
      information_losses: "喪失情報",
      not_applicable_over_70_years: "70歳不該当年月日",
    },
  
    Childcare_Applicationde: {
      Basicinformation: "基本情報",
      Insuredreferencenumber: "整理番号",
      Selectemployee: "社員選択",
      holidaystarttime: "育児休業等開始年月日",
      scheduledendtime: "育児休業等終了予定年月日",
      childinformation: "子供の情報",
      familyname: "姓名",
      category: "区分",
      childbirthday: "養育する子の生年月日",
      thedateofparenting: "養育開始年月日",
      givenname: "名",
      note: "備考",
      others: "その他",
      pplicabletomaternityleave: "パパママ育休該当",
      incaseofpostponement: "予定より早く育児休業を終了した場合",
      actualenddate: "育児休業等終了年月日",
      operating: "操作",
      detail: "詳細",
      edit: "編集",
      print: "印刷",
      create: "新規",
      cancle: "キャンセル",
      logicnumber: "整理番号",
      update: "更新",
      ok: "ok",
      review: "レビュー",
    },
  
    Childcare_Application_Salary_Changede: {
      Basicinformation: "基本情報",
      Insuredreferencenumber: "整理番号",
      Selectemployee: "社員選択",
      holidaystarttime: "育児休業等開始年月日",
      scheduledendtime: "育児休業等終了予定年月日",
      childinformation: "子供の情報",
      familyname: "姓名",
      category: "区分",
      childbirthday: "養育する子の生年月日",
      thedateofparenting: "養育開始年月日",
      givenname: "名",
      note: "備考",
      others: "その他",
      incaseofpostponement: "予定より早く育児休業を終了した場合",
      salarychange: "給料",
      actualenddate: "育児休業等終了年月日",
      attendancemonth: "出勤月",
      attendancedays: "出勤日数",
      currency: "通貨",
      spot: "現物",
      total: "合計",
      grandtotal: "総計",
      averageamount: "平均額",
      revisedaverage: "修正平均額",
      operating: "操作",
      detail: "詳細",
      edit: "編集",
      print: "印刷",
      create: "新規",
      cancle: "キャンセル",
      logicnumber: "整理番号",
      update: "更新",
      ok: "ok",
      review: "レビュー",
  
    },
  
    //EmpIns
  
    empIns1: {
      office_name: "事業所の名称",
      office_address: "住所",
      change_office_name: "変更名称",
      change_office_name_phonetic: "変更名称「ﾌﾘｶﾞﾅ」",
      change_name: "変更氏名",
      change_name_phonetic: "変更氏名「ﾌﾘｶﾞﾅ」",
      date: "日付",
      change_date: "変更年月日",
      business_start_day: "事業開始日",
      change_address: "変更住所",
      change_address_phonetic: "変更住所「ﾌﾘｶﾞﾅ」",
      reason: "変更の理由",
      overview_after_change_business: "変更後の事業の概要",
      employment_insurance_section_name: "雇用保険担当課名",
      remark: "備考",
      wages_deadline: "賃金締切日",
      wage_payment_date: "賃金支払日",
      month: "月",
      day: "日",
      company_info: "会社情報",
      change_info: "変更情報",
      cant_change: "以下の会社情報は変更できません",
      installation_date: "設置年月日",
      tel: "電話番号",
      employment_ins_no: "雇用保険被保険者数",
      general_worker: "一般",
      daily_worker: "日雇",
      person: "人",
      note: "変更情報「以下に変更したい区分だけ入力してください」",
      dateRule: "日付を入力してください。",
      changeDateRule: "変更年月日を入力してください。",
      changeBeginDateRule: "賃金締切日を入力してください。",
      this_month: "当",
      next_month: "翌",
    },
    empIns2: {
      office_name: "事業所の名所",
      remark: "備考",
      installation_date: "設置年月日",
      emp_ins_section_name: "雇用保険担当課名",
      social_ins: "社会保険加入状況",
      social_ins_health_part: "健康保険",
      social_ins_pension_part: "厚生年金保険",
      social_ins_accident_part: "労災保険",
      enter_installation_date: "設置年月日を入力してください！",
      enter_name_in_charge: "雇用保険担当課名を入力してください！",
    },
  
    //new
    empIns3: {
      applicant: "申請者",
      submit_date: "申請年月日",
      left_code: "離職票交付番号",
      left_date: "離職票交付年月日",
      left_cause: "離職票再交付の理由",
      re_date: "再交付年月日",
      things: "交付を希望するもの",
      name: "社員氏名",
      things1: "離職票－1",
      things2: "離職票－2",
      loss: "滅失",
      damage: "損傷",
      emp_name: "社員氏名",
    },
    empIns4: {
      basic1: "基本情報",
      basic2: "保険情報",
  
      date: "日付",
      employee_id: "社員番号",
      name: "被保険者氏名",
      name_frgn: "被保険者氏名「フリガナ」",
      mynum: "個人番号",
      birthday: "出生年月",
      gender: "性別",
      nation: "国籍・地域",
      resident: "在留資格",
  
  
      change_name: "変更後の氏名",
      change_name_frgn: "変更後の氏名「フリガナ」",
  
      period_of_stay: "在留期間（満了日）",
      qualification_activity_permission: "資格外活動許可の有無",
      working_category: "派遣・請負就労区分",
  
      genin_code: "被保険者となった原因",
      shutoku_kuben_code: "取得区分",
      salary_type_code: "賃金種類",
      salary_amount: "賃金金額",
      thousand: "千円",
      shutoku_date: "資格取得年月日",
      employment_type_code: "雇用形態",
      profession_type_code: "職種",
      inaugural_type_code: "就職経路",
      week_work_time: "１週間の所定労働時間",
      hour: "時間",
      minute: "分",
      remark: "備考",
  
      contract_type: "契約期間の定め",
      contract_start_date: "契約期間",
      contract_update_type_code: "契約更新条項の有無",
      from: "から",
      to: "まで",
  
      new: "新規",
      reacquire: "再取得",
  
      new_graduate: "新規雇用（新規学卒）",
      new_other: "新規雇用（その他）",
      from_daily: "日雇からの切替",
      over60: "出向元への復帰等（65歳以上）",
  
      monthly: "月給",
      weekly: "週給",
      dailypay: "日給",
      hourly: "時間給",
  
      daily: "日雇",
      part_time: "パートタイム",
      dispatch: "派遣",
      contract_worker: "有期契約労働者",
      seasonal: "季節的雇用",
      sailor: "船員",
  
      admin: "管理的職業",
      technical: "専門的・技術的職業",
      office: "事務的職業",
      sale: "販売の職業",
      service: "サービスの職業",
      security: "保安の職業",
      agriculture: "農林漁業の職業",
      production: "生産工程の職業",
      transportation: "輸送・機械運転の職業",
      construction: "建設・採掘の職業",
      cleaning: "運搬・清掃・包装等の職業",
  
      stable_company: "安定所紹介",
      self_employment: "自己就職",
      private_sector: "民間紹介",
      not_grasp: "把握していない",
  
      exist: "有",
      not_exist: "無",
  
      one: "1. 派遣・請負労働者として主に当該事業所以外で就労する",
      two: "2. 1に該当しない",
  
      fill: "入力してください。",
  
  
      logicnumber: "整理番号",
  
  
      pleaseselect: "選択してください",
  
  
    },
  
  
    empIns5: {
      empInfo: "従業員情報",
      employee_id: "社員番号",
      emp_name: "社員氏名",
      category: "届出区分",
      mynum: "個人番号",
      date: "日付",
      ins_no: "被保険者番号",
      note: "メモ欄",
      new_mynum: "新しい個人番号",
      new: "1.新規",
      change: "2.変更",
      dateRule: "日付を入力してください。",
      new_mynumRule: "新しいの個人番号を入力してください。",
      categoryRule: "届出区分を選んでしてください。",
      rules: "選んでください"
    },
    empIns6: {
      career_type: "職種",
      work_per_week: "一週間の所定労働",
      work_hour: "一週間の所定労働時間",
      work_minute: "一週間の所定労働分",
      pay_amount: "賃金月額",
      employ_period: "雇用期間",
      employ_period_date: "定めあり年月日",
      employ_contract_renewal: "契約更新条項有",
      employ_period_oneyear: "1年を超えて労用する見込み",
      proof_date: "証明年月日",
      has_allowance: "再就職手当受給",
      application_date: "申請年月日",
      employee_id: "社員番号",
      name: "社員氏名",
      business_owner_proof: "事業主の証明",
      hour: "時間",
      min: "分",
      enter_career_type: "職種を入力してください！",
    },
    empIns7: {
      office_name: "事業所名称",
      address: "事業所住所",
      chairman_name: "事業主氏名",
      date: "日付",
      abo_info: "廃止情報",
      abo_category: "廃止区分",
      category1: "1. 事業所の廃止",
      category2: "4. 事業所の統合に伴う事業所の廃止",
      abo_reason: "廃止理由",
      reason:"理由",
      abo_date: "廃止年月日",
      establish_no: "統合先事業所の事業所番号",
      establish_date: "統合先事業所の設置年月日",
      company_info: "会社情",
      tel: "電話番号",
      cant_change: "以下の会社情報は変更できません。",
      abo_dateRule: "廃止年月日を入力してください。",
      business_codeRule: "統合先事業所の事業所番号を入力してください。",
      business_dateRule: "統合先事業所の設置年月日を入力してください。",
      dateRule: "日付を入力してください。",
      businessHintTitle: "事業所番号",
      businessHintMsg: "公共職業安定所から通知された事業所番号を４桁から１３桁まで入してください。",
      emptyAlertTitle: "入力エラー",
      emptyAlertMsg: "全部入してください。",
    },
    empIns8de: {
      numberofpeople: "雇用保険法を適用しない者の種類別人数",
      occupation: "雇用保険法を適用しない者の職種",
      numberofpeople2: "雇用保険法を適用しないことについての申請をしない者の人数",
      occupation2: "雇用保険法を適用しないことについての申請をしない者の職種",
      officename: "公署の名称",
      address: "所在地",
      date: "日付",
      nameApply: "申請者の職氏名",
      open1Title: "申請者の職氏名とは",
      open1Msg: "普通は代表者の氏名です。",
  
    },
    //new
    empIns9: {
      name_change_date: "氏名変更年月日",
      name: "被保険者氏名",
      new_name: "新氏名",
      cause: "雇用保険喪失原因",
      nation: "国籍・地域",
      resident: "在留資格",
      resident_date: "在留期間",
      form16: "派遣・請負",
      form25: "なくなったことの原因",
      form9: "補充採用予定の有無",
      nospace: "1有 空白無",
      week_time: "１週間の所定労働時間",
      time: "時間",
      new_namefrgn: "新氏名フリガナ",
      wish: "離職票交付希望",
      changeOrloss: "0氏名変更届 1資格喪失届",
      yesno: "1有 2無",
      yes: "有",
      no: "無",
      change: "氏名変更届",
      loss: "資格喪失届",
      aus: "AUS-オーストラリア",
      bra: "BRA-ブラジル",
      mmr: "MMR-ミャンマー",
      can: "CAN-カナダ",
      chn: "CHN-中国",
      fra: "FRA-フランス",
      deu: "DEU-ドイツ",
      hkg: "HKG-中国香港",
      ind: "IND-インド",
      jpn: "JPN-日本",
      kor: "KOR-韓国",
      phl: "PHL-フィリピン",
      twn: "TWN-台湾",
      tha: "THA-タイ",
      usa: "USA-アメリカ",
      vnm: "VNM-ベトナム",
      r1: "01-教授",
      r2: "02-芸術",
      r3: "03-宗教",
      r4: "04-報道",
      r5: "05-高度専門職１号",
      r6: "06-高度専門職２号",
      r7: "07-経営・管理",
      r8: "08-法律・会計業務",
      r9: "09-医療",
      r10: "10-研究",
      r11: "11-教育",
      r12: "12-技術・人文知識・国際業務",
      r13: "13-企業内転勤",
      r14: "14-介護",
      r15: "15-興行",
      r16: "16-技能",
      r17: "17-特定技能１号",
      r18: "18-特定技能２号",
      r19: "19-技能実習１号",
      r20: "20-技能実習２号",
      r21: "21-技能実習３号",
      r22: "22-文化活動",
      r23: "23-短期滞在",
      r24: "24-留学",
      r25: "25-研修",
      r26: "26-家族滞在",
      r27: "27-特定活動",
      r28: "28-永住者",
      r29: "29-日本人の配偶者等",
      r30: "30-永住者の配偶者等",
      r31: "31-定住者",
      cause1: "1.離職以外の理由",
      cause2: "2.3以外の離職",
      cause3: "3.事業主の都合による離職",
      form1: "1.派遣・請負労働者として主に当該事業所以外で就労していた場合",
      form2: "2.1に該当しない場合",
    },
    empIns10de: {
      logicid: "業務ID",
      leavetime: "離職年月日",
      createtime: "喪失年月日",
  
      insuranceid: "保険番号",
      name: "保険者氏名",
      selectemployee: "社員番号",
  
    },
    empIns12: {
      new_com_code: "事業所番号",
      transfer_day: "転勤年月日",
      memo: "メモ欄",
      date: "提出日",
      employee_id: "社員番号",
      name: "社員氏名",
      enter_new_com_code: "事業所番号を入力してください！",
      enter_transfer_day: "転勤年月日を入力してください！",
      enter_date: "提出日を入力してください！",
    },
    empIns13: {
      employee_id: "社員番号",
      emp_name: "氏名",
      emp_name_pho: "氏名「ローマ字」",
      national: "国籍",
      birthday: "生年月日",
      branch: "個人別票の枝番号",
      re_employ: "再就職",
      resident_card: "在留カード番号",
      branch_noRule: "「雇用保険被保険者取得届（連記式） 個人別票」 に添付する場合のみ記入。",
      yes: "はい",
      no: "いいえ",
      attachHintTitle: "個人別票の枝番号",
      attachHintMsg: "「雇用保険被保険者取得届（連記式） 個人別票」 に添付する場合のみ記入してください。",
      firstHintTitle: "被保険者番号",
      firstHintMsg: "はじめて雇用保険の被保険者となる場合は生年月日を記入します。",
    },
    empIns14: {
      resident_date: "在留期間（期限）",
      license: "活動許可の有無",
      report_date: "提出日",
      license: "活動許可の有無",
      work_at_other_business: "労働者として主として他の事業所で就労する?",
      employee_id: "社員番号",
      name: "社員氏名",
      enter_resident_date: "在留期間を入力してください！",
    },
  
  
    //Scoial Ins
  
    attorney_power: {
      delegation_date: "委任日",
      delegation_content: "委任する内容",
      death_my_num: "基礎年金番号（死亡）",
      death_relation: "委任者(ご本人)との続柄(死亡)",
      death_name: "氏名（死亡）",
      death_birth_date: "生年月日（死亡）",
      other_content: "その他内容",
      period_amount_wished: "年金の「加入期間」 や「見込額」などの交付方法ありますか？",
      kibou: "希望",
      delegator: "委任者",
      employee_id: "社員番号",
      name: "社員氏名",
      trustee: "受任者",
      trustee_name_furi: "フリガナ",
      trustee_name: "氏名",
      relation_with_delegator: "委任者(ご本人)との関係",
      trustee_postcode: "郵便番号",
      trustee_phone_no: "電話番号",
      trustee_address: "住所",
      address: "市・区・郡及び町村名",
      hint_open1: "委任する内容を次の項目から選ぶか、具体的に記入してください。",
      hint_open2: "年金の「加入期間」や「見込額」などの交付方法について次のいずれかを選んでください。",
      enter_employee_id: "社員番号を入力してください",
    },
    pension_reissue: {
      report_date: "提出年月日",
      phone_type: "電話番号種類",
      reason: "申請事由",
      system_name: "制度の名称",
      acquisition_date: "取得年月日",
      loss_date: "喪失年月日",
      employee_id: "社員番号",
      name: "社員氏名",
      enter_reason: "申請事由を入力してください",
      hint_open1: "現在、加入している又は最後に加入していた公的年金制度の資格取得日を記入してください。",
      hint_open2: "次のいずれかを○で囲んでください。 １.紛失：  紛失した場合     ２.破損（汚れ）：    破れた又は汚れた場合   ※この場は損した年金手帳を書に添付してください。   ９．その他：   年金手帳が交付されていない場合等  （※通常は使用しません）",
      hint_open3: "現在、加入している公的年金制度について次のいずれかを○で選んでください。また勤務していた事業所を退職し国民年金へ切り替える、又は厚生年金保険若しくは船員保険の事業所へ勤務しようとしている場合は、最後に勤務していた事業所が加入していた公的年金制度について次のいずれかを○で囲んでください。 １．国民年金　　：現在、国民年金に加入中の場合 ２．厚生年金保険：現在、厚生年金保険に加入中の場合、又は最後に勤務していた事業所が厚生年金保険の事業所である場合 ３．船員保険　　：現在、船員保険に加入中の場合、又は最後に雇用されていた船舶（事業所）が船員保険の船舶所有者（事業所）である場合  ４．共済組合　　：現在、共済組合に加入中の場合、又は最後に勤務していた事業所が共済組 ",
    },
  
    //Pension
  
    pensionbasicde: {
      member: "社員選択",
      april: "４月",
      may: "５月",
      june: "６月",
      workingdays: "日数",
      currency: "通貨",
      stocks: "現物",
      total: "合計",
      grandtotal: "総計",
      average: "平均額",
      adjustedaverage: "修正平均額",
      holidaystarttime: "休暇開始",
      holidayendtime: "休暇終了",
      retroactivepayment: "遡及支払",
      retroactivepaymentmonth: "遡及支払月",
      latedelivery: "遅配",
      Settlementday: "給料基準日",
      payday: "支払",
      entertime: "入社時間",
      leaveofabsence: "休暇",
      companyinformation: "会社情報",
      pensionadmin: "報酬月額管理",
      pensionbasic: "報酬月額",
      general: "社員",
      Temporaryreturn: "一時帰休",
      midcareer: "途中入社",
      parttime: "パート",
      reducedworking: "短時間労働",
      leave: "休暇",
      Automaticcalculation: "自動計算",
      payoff: "精算",
      clear: "クリア",
      save: "保存",
      create: "新規",
      cancle: "キャンセル",
      logicnumber: "整理番号",
      update: "更新",
      ok: "完成した",
      review: "レビュー",
      basic: "基本",
      pleaseselect: "選択してください",
      confirm: "確認",
    },
    pensionadminde: {
      memberid: "社員番号",
      name: "氏名",
      notice: "備考",
      detail: "詳細",
      edit: "編集",
      print: "印刷",
      title: "操作",
    },
  
  
    //CalcuFunction
  
    NKHK: {
      name: "報酬額:",
      name_type: "報酬額種類:",
      salary: "給料",
      bonus: "賞与",
  
      age: "年齢:",
      under40: "40歳未満",
      over40: "40歳以上65歳未満",
      over65: "65歳以上",
      over70: "70歳以上",
  
      address: "事業所住所:",
      hokkaido: "北海道",
      aomori: "青森県",
      iwate: "岩手県",
      miyagi: "宮城県",
      akita: "秋田県",
      yamagata: "山形県",
      fukushima: "福島県",
      ibaraki: "茨城県",
      tochigi: "栃木県",
      gunma: "群馬県",
      saitama: "埼玉県",
      chiba: "千葉県",
      tokyo: "東京都",
      kanagawa: "神奈川県",
      niigata: "新潟県",
      toyama: "富山県",
      ishikawa: "石川県",
      fukui: "福井県",
      yamanashi: "山梨県",
      nagano: "長野県",
      gifu: "岐阜県",
      shizuoka: "静岡県",
      aichi: "愛知県",
      mie: "三重県",
      shiga: "滋賀県",
      kyoto: "京都府",
      osaka: "大阪府",
      hyogo: "兵庫県",
      nara: "奈良県",
      wakayama: "和歌山県",
      tottori: "鳥取県",
      shimane: "島根県",
      okayama: "岡山県",
      hiroshima: "広島県",
      yamaguchi: "山口県",
      tokushima: "徳島県",
      kagawa: "香川県",
      ehime: "愛媛県",
      kochi: "高知県",
      fukuoka: "福岡県",
      saga: "佐賀県",
      nagasaki: "長崎県",
      kumamoto: "熊本県",
      oita: "大分県",
      miyazaki: "宮崎県",
      kagoshima: "鹿児島県",
      okinawa: "沖縄県",
  
      busType: "事業種類:",
      forestry: "林業",
      sea_fishery: "海面漁業",
      net_fishery: "定置網漁業又は海面魚類養殖業",
      mining: "金属鉱業、非金属鉱業",
      limestone_mining: "石灰石鉱業又はドロマイト鉱業",
      gas_mining: "原油又は天然ガス鉱業",
      quarring: "採石業",
      other_mining: "その他の鉱業",
      hydro: "水力発電施設、ずい道等新設事業",
      road: "道路新設事業",
      paving: "舗装工事業",
      railway: "鉄道又は軌道新設事業",
      construction_business: "建築事業",
      equipment: "既設建築物設備工事業",
      machinery: "機械装置の組立て又は据付けの事業",
      other_construction: "その他の建設事業",
      food_manufacturing: "食料品製造業",
      textile: "繊維工業又は繊維製品製造業",
      wood: "木材又は木製品製造業",
      paper: "パルプ又は紙製造業",
      printing: "印刷又は製本業",
      chemical: "化学工業",
      glass: "ガラス又はセメント製造業",
      concrete: "コンクリート製造業",
      ceramic: "陶磁器製品製造業",
      other_ceramic: "その他の窯業又は土石製品製造業",
      metal: "金属精錬業",
      non_metal: "非鉄金属精錬業",
      metal_material: "金属材料品製造業",
      foundry: "鋳物業",
      metal_product: "金属製品製造業又は金属加工業",
      tableware: "洋食器、刃物、手工具又は一般金物製造業",
      metalwork: "めつき業",
      machinery_part: "機械器具製造業",
      electric: "電気機械器具製造業",
      transportation_eqip: "輸送用機械器具製造業",
      ship: "船舶製造又は修理業",
      clock: "計量器、光学機械、時計等製造業",
      jewelry: "貴金属製品、装身具、皮革製品等製造業",
      other_manufacturing: "その他の製造業",
      transportation: "交通運輸事業",
      freight: "貨物取扱事業",
      cargo: "港湾貨物取扱事業",
      harbor: "港湾荷役業",
      gas_supply: "電気、ガス、水道又は熱供給の事業",
      fisheries: "農業又は海面漁業以外の漁業",
      cleaning: "清掃、火葬又はと畜の事業",
      building_maintenance: "ビルメンテナンス業",
      warehouse: "倉庫業、警備業、消毒又は害虫駆除の事業",
      telecommunication: "通信業、放送業、新聞業又は出版業",
      lodging: "卸売業・小売業、飲食店又は宿泊業",
      finance: "金融業、保険業又は不動産業",
      other_various: "その他の各種事業",
      ship_owner: "船舶所有者の事業",
  
      busTime: "期間",
      h16_8: "平成16年8月分まで",
      h16_9: "平成16年9月~17年8月分",
      h17_9: "平成17年9月~18年8月分",
      h18_9: "平成18年9月~19年8月分",
      h19_9: "平成19年9月~20年8月分",
      h20_9: "平成20年9月~21年8月分",
      h21_9: "平成21年9月~22年8月分",
      h22_9: "平成22年9月~23年8月分",
      h23_9: "平成23年9月~24年8月分",
      h24_9: "平成24年9月~25年8月分",
      h25_9: "平成25年9月~26年8月分",
      h26_9: "平成26年9月~27年8月分",
      h27_9: "平成27年9月~28年8月分",
      h28_9: "平成28年9月分",
      h28_10: "平成28年10月~29年8月分",
      h29_9: "平成29年9月分以降",
  
      resource: "事業種類:",
      general: "一般",
      agriculture: "農林水産・清酒製造",
      construction: "建設",
  
      calculate: "合計",
      clear: "リセット",
  
      yen: "円",
  
      pension_result: "厚生年金保険料の計算結果:",
      standard_reward: "標準報酬額：",
      insurance_fee: "保険料：",
      emp: "従業員分：",
  
      emp_ins_result: "雇用保険料の計算結果:",
      emp_burden: "従業員負担：",
      chairman_burden: "事業主負担：",
      emp_ins_fee: "雇用保険料：",
  
      accident_ins_result: "労災保険料の計算結果:",
      accident_ins_fee: "労災保険料：",
  
      health_ins_result: "健康保険料の計算結果:",
      ins_type: "保険の種類：",
      rate: "料率",
      health_ins: "健康保険：",
      nurse_ins: "介護保険：",
  
      subtotal: "小計：",
      ins_total: "保険合計：",
  
      alert: "入力が間違っています。再入力してください。",
    },
  
    //new
    JDSLoan: {
      moneyAmount: "ご希望お借入金額 1,000万円以内で入力してください。:",
      loanAmount: "お借入金額の50%以内でボーナス返済ご希望額を入力してください。:",
      desiredPeriod: "ご希望お借入期間 (6ヵ月以上10年以内で入力してください.) :",
  
      calculate: "合計",
      clear: "クリア",
  
      interest_rate: "金 利 :",
      S1: "毎月の返済額:",
      S2: "ボーナス月の返済額:",
  
      ten_thousand: "万円",
      yen: "円",
      year: "年",
      month: "ヵ月",
  
      p1Alert: "入力されていない項目があります！！",
      p2Alert: "ご返済期間を入力してください！！",
  
      err_msg1: "間違いがあります!!",
      err_msg2: "お借入金額が間違っています！！",
      err_msg3: "ご返済期間が間違っています！！",
      wrong_bonus: "ボーナス返済額が間違っています！！",
      over_bonus: "ボーナス返済額の最大は、",
      is_ten_thousand: "万円です！！",
      not_number: "数字ではない項目があります!!",
      wrong_rate: "金利の入力値に誤りがあります!!",
    },
  
    //new
    monthLoan: {
      fill_month: "月を入力してください",
      search: "探索",
      month: "月",
      permanent: "常時使用労働者",
      officer: "役員労働者",
      temporary: "臨時労働者",
      total: "合計",
  
      people: "人数",
      loan: "貸金",
  
      fill: "入力してください"
    },
  
  
  
  
  
  };


// WEBPACK FOOTER //
// ./src/i18n/locale/ja.js